/**
 * 保留 JSON 响应中的超长整数精度。
 *
 * 原生 JSON.parse 会把超过 Number.MAX_SAFE_INTEGER 的 ID 立即舍入，展示层再转字符串也无法恢复。
 * 这里仅在字符串外识别 JSON 数字；超出安全范围的纯整数先改写为 JSON 字符串，再统一解析。
 * 小数、指数和安全整数维持 number，避免影响计数、金额等常规字段。
 */
export function parseJsonWithLongIntegers(raw: string): unknown {
  if (!raw) return raw;
  let result = '';
  let index = 0;
  let inString = false;
  let escaped = false;

  while (index < raw.length) {
    const char = raw[index];
    if (inString) {
      result += char;
      if (escaped) escaped = false;
      else if (char === '\\') escaped = true;
      else if (char === '"') inString = false;
      index += 1;
      continue;
    }
    if (char === '"') {
      inString = true;
      result += char;
      index += 1;
      continue;
    }
    if (char !== '-' && (char == null || char < '0' || char > '9')) {
      result += char;
      index += 1;
      continue;
    }

    const start = index;
    if (raw[index] === '-') index += 1;
    while (index < raw.length && raw[index]! >= '0' && raw[index]! <= '9') index += 1;
    let isInteger = true;
    if (raw[index] === '.') {
      isInteger = false;
      index += 1;
      while (index < raw.length && raw[index]! >= '0' && raw[index]! <= '9') index += 1;
    }
    if (raw[index] === 'e' || raw[index] === 'E') {
      isInteger = false;
      index += 1;
      if (raw[index] === '+' || raw[index] === '-') index += 1;
      while (index < raw.length && raw[index]! >= '0' && raw[index]! <= '9') index += 1;
    }
    const token = raw.slice(start, index);
    const shouldQuote =
      isInteger &&
      token !== '-' &&
      (BigInt(token) > BigInt(Number.MAX_SAFE_INTEGER) ||
        BigInt(token) < BigInt(Number.MIN_SAFE_INTEGER));
    result += shouldQuote ? JSON.stringify(token) : token;
  }

  return JSON.parse(result);
}
